export const getRepeatsCount = (duration?: number | null, playDuration?: number | null) =>
  (duration && playDuration && Math.round(playDuration / duration)) || 0;
